<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-container fluid class="p-0 m-0 ">
          <b-row  align-v="stretch">
            <b-col>
              <h4>{{ $t('nav.tags_list_title') }}</h4>
            </b-col>
            <b-col cols="12" md="auto">
              <!-- <b-button-group> -->
                <b-button v-if="!loading && list.actions && list.actions.create" class="mb-3" variant="primary" :to="{ name: 'TagCreate' }">
                  {{ $t('tag.create_new') }}
                </b-button>
              <!-- </b-button-group> -->
            </b-col>
          </b-row>
          <b-row  align-v="stretch">
            <b-col>
              <b-form-group>
                <b-input-group>
                  <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="getData()"><i class="fa fa-search"/></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="auto">
              <b-form-group  >
                <b-input-group :prepend="$dt('global.per_page', 'Per page:')">
                  <b-form-select :options="[2,10,20,50,100,500]" v-model="filters.per_page" />
                </b-input-group>
                <!-- <b-input-group :prepend="$dt('global.per_page', 'Per page:')">
                  <b-form-select :options="[2,10,20,50,100,500]" v-model="filters.per_page" />
                </b-input-group> -->
              </b-form-group>
            </b-col>
            <b-col cols="12" md="auto" v-if="listPaginator.last_page > 1" >
                <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </b-container>
         <!-- <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else> -->
        <b-container fluid style="padding:0; margin:2em 0 0 0 ;">
         <!-- <b-row>
            <b-col> -->
              <!-- <NoDataView v-if="!tableItems.length"/> -->
              <!-- <b-table v-else class="table-sm text-center" responsive outlined hover head-variant="light"
                  :no-local-sorting=true
                  :sort-by.sync="filters.sort_field"
                  :sort-desc.sync="filters.sort_order"
                  :fields="tableFields"
                  :items="tableItems"
                  >
                <template v-slot:cell(options)="row">
                  <div class="flex-container options-center">
                  <router-link v-if="row.item.actions.update" :to="{ name: 'TagUpdate', params:{ id: row.item.id }}">
                    <a><i class="mx-1 fa fa-edit fa-lg"/></a>
                  </router-link>
                  <Delete v-if="row.item.actions.delete"  :id="row.item.id" @deleted="getData" :deleteFn="()=>deleteFn(row.item.id)" />
                  </div>
                </template>
              </b-table> -->
              <div v-for="tag in tableItems" :key="tag.id" class="mx-1 p-1 tag-badges">

                  <span>{{tag.name}}</span>
                  <router-link v-if="tag.actions.update" :to="{ name: 'TagUpdate', params:{ id: tag.id }}">
                    <i class="mx-1 fa fa-edit fa-lg"/>
                  </router-link>
                  <Delete type="span" v-if="tag.actions.delete"  :id="tag.id" @deleted="getData" :deleteFn="()=>deleteFn(tag.id)" />
              </div>
            <!-- </b-col>
          </b-row> -->

          <!-- <b-row> -->
          <!-- Paginator at bottom -->
          <div v-if="tableItems.length">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </div>
        </b-container>
        <!-- </div> -->
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      // tableFields: [
      //   { key: 'id', sortable: true, label: this.$t('global.id') },
      //   { key: 'name', sortable: true, label: this.$t('tag.name') },
      //   { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
      //   { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
      //   { key: 'options', label: this.$t('global.options') }
      // ],
      filters: {
        sort_field: 'id',
        sort_order: true,
        search: '',
        per_page: 20,
      },
      loading: false,
      list: {},
    };
  },
  components: {
    Pagination, NoDataView, Delete
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.tags.list(this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'Tags', params: { page } });
    },
    deleteFn(id) {
      return Services.tags.delete(id);
    }
  }
};
</script>

<style lang=scss>
  .tag-badges{
    white-space: nowrap;
    margin: 5px;
    display: inline-block;
    border-radius: 5px;
    background-color: $secondary;
    color:$white;
    &>div{
      display: inline-block;
      overflow: auto;
    }
  }
</style>
